import styled from 'styled-components';

const ChildrenContainer = styled.div<{underline?: boolean}>`
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  :last-of-type {
    padding-inline-end: var(--btn-internals-full-padding);
  }
  :first-of-type {
    padding-inline-start: var(--btn-internals-full-padding);
  }
  ${({underline}) =>
    underline &&
    `
    text-decoration: underline;
  `}
`;

export default ChildrenContainer;
